import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { ReactLink } from '@dfl/react-security';
import { format } from 'date-fns';
import AuditRateCell from 'modules/audit/management/components/AuditRateCell/AuditRateCell';
import { AuditRowActions } from 'modules/audit/management/components/AuditRowActions';
import { AUDIT_PERMISSIONS } from 'modules/audit/management/constants/audit.permissions';
import { AuditStatus, IAudit } from 'modules/audit/management/interfaces';
import { areaColumn, codeColumn } from 'modules/common/constants';
import AuditStatusChip from '../components/Chips/AuditStatusChip';

export const auditNameColumn: HeadCell<IAudit> = {
  field: 'name',
  headerName: 'audit:fields.name',
  disablePadding: false,
  renderCell: (name: string, data: IAudit) => (
    <ReactLink key={data._id} to={`/audit/${data._id as string}/general`}>
      {name}
    </ReactLink>
  ),
};

export const auditClientColumn: HeadCell<IAudit> = {
  field: 'client.name',
  headerName: 'audit:fields.client',
};

export const auditEstablishmentColumn: HeadCell<IAudit> = {
  field: 'establishment.name',
  headerName: 'audit:fields.establishment',
};

export const auditStartDateColumn: HeadCell<any> = {
  field: 'startDate',
  align: CellAlign.CENTER,
  headerName: 'audit:fields.startDate',
  renderCell: (startDate: string) => {
    if (!startDate) return null;
    const date = new Date(startDate);
    return format(date, 'dd/MM/yyyy');
  },
};
export const auditEndDateColumn: HeadCell<any> = {
  field: 'endDate',
  align: CellAlign.CENTER,
  headerName: 'audit:fields.endDate',
  renderCell: (endDate: string) => {
    if (!endDate) return null;
    const date = new Date(endDate);
    return format(date, 'dd/MM/yyyy');
  },
};
export const auditStatusColumn: HeadCell<IAudit> = {
  field: 'status',
  headerName: 'audit:fields.status',
  align: CellAlign.CENTER,
  renderCell: (status: string, data: IAudit) => <AuditStatusChip value={data?.status} />,
};

export const auditRateColumn: HeadCell<IAudit> = {
  field: 'maxScore',
  headerName: 'audit:fields.rate',
  align: CellAlign.CENTER,
  renderCell: (maxScore: string, data: IAudit) =>
    data?.status === AuditStatus.COMPLETED ? (
      <AuditRateCell number={data?.score && data?.maxScore ? (data?.score / data?.maxScore) * 100 : 0} />
    ) : (
      <strong>-</strong>
    ),
};

export const auditActionsColumn: HeadCell<IAudit> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: AUDIT_PERMISSIONS.WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  align: CellAlign.CENTER,
  component: AuditRowActions,
};

export const auditColumns: Array<HeadCell<any>> = [
  auditNameColumn,
  codeColumn,
  auditClientColumn,
  auditEstablishmentColumn,
  areaColumn,
  auditStartDateColumn,
  auditEndDateColumn,
  auditStatusColumn,
  auditRateColumn,
  auditActionsColumn,
];
